export const JUDICIAL_CIVEL_COMPLEMENTO = (judicialCivel) => `Garantia Judicial destinada ao Processo nº ${judicialCivel.processNumber ?? '[nº do processo]'}. Trata-se de ${judicialCivel.proposedLegalAction ?? '[ação proposta]'} movida por ${judicialCivel.name?.replace('.', '') ?? '[nome]'}, ${judicialCivel.document ?? '[CPF/CNPJ]'}, perante a ${judicialCivel.courtSection ?? '[vara]'}.\n ${judicialCivel.complementObjectText?.trim() ?? ''}`

const JudicialGuaranteeCivelQuotation = {
  JUDICIAL_CIVEL_COMPLEMENTO,
}

export default JudicialGuaranteeCivelQuotation
